export const twitterMostViewedVideosCopy = {
  title: 'Most Viewed Videos',
  tooltip: 'Your Posts that received the highest number of views during the selected date range',
  emptyMessage: 'No X videos found during this reporting period',
};

export const tooltips = {
  noBrandPermission: "Looks like this feature isn't included in your plan!",
  noUserPermission: "Looks like you don't have permission to use this feature!",
  connectCallToAction:
    "Dash Social brings you all of the insights you love, including X! Ask your Dash Social administrator to provide you access. Or if this feature isn't in your package, contact your Customer Success Representative to try it out!",

  engagementRate:
    'The percentage of your audience that engaged with your organic Posts. Engagement Rate = Total Engagements / Impressions',
  engagements:
    'The total number of times your organic Posts have been interacted with. Includes reposts, replies, likes, and clicks.',
  impressions: 'The number of times your organic Posts were viewed.',
  likes: 'The number of times your organic Posts have been liked.',
  linkClicks: 'The number of times links have been clicked on your organic Posts.',
  netNewFollowers: 'The net number of new followers you gained during the selected time period.',
  replies: 'The number of times your organic Posts have been replied to.',
  totalRetweets: 'The number of times your organic Posts have been reposted or quote posted.',
  userProfileClicks: 'The number of times your profile has been clicked from your organic Posts.',
  videoViews: 'The number of times your organic videos have been viewed.',
};

export const defaultGraphMetric = 'TOTAL_ENGAGEMENTS';

export const PROMOTED_METRICS_CUTOFF_DATE = '2026-04-30';

export const timeScaleTypes = {
  DAILY: {
    value: 'DAILY',
    label: 'By Day',
  },
  MONTHLY: {
    value: 'MONTHLY',
    label: 'By Month',
  },
};

export const twitterMediaCardDefaults = {
  labels: {
    engagements: 'Total Engagements',
    urlClicks: 'Link Clicks',
    follows: 'User Follows',
    userProfileClicks: 'Profile Clicks',
  },
  metrics: ['engagementRate', 'engagements', 'impressions', 'likes'],
};

export const filterTypes = {
  GRAPH: 'Graph',
  DATE: 'Date',
  SCALE: 'Scale',
};

export const twitterTopLineStatsMetrics = [
  {
    value: 'NEW_FOLLOWERS',
    label: 'Net New Followers',
    tooltip: tooltips.netNewFollowers,
  },
  {
    value: 'ENGAGEMENTS_TOTAL',
    label: 'Total Engagements',
    tooltip: tooltips.engagements,
    extendedMetrics: [
      {
        value: 'ENGAGEMENTS_ORGANIC',
        label: 'Organic',
      },
      {
        value: 'ENGAGEMENTS_PROMOTED',
        label: 'Promoted',
      },
    ],
  },
  {
    value: 'AVG_ENGAGEMENT_RATE_TOTAL',
    label: 'Avg. Engagement Rate',
    tooltip: tooltips.engagementRate,
    percent: true,
    extendedMetrics: [
      {
        value: 'AVG_ENGAGEMENT_RATE_ORGANIC',
        label: 'Organic',
        percent: true,
      },
      {
        value: 'AVG_ENGAGEMENT_RATE_PROMOTED',
        label: 'Promoted',
        percent: true,
      },
    ],
  },
  {
    value: 'LIKES_TOTAL',
    label: 'Likes',
    tooltip: tooltips.likes,
    extendedMetrics: [
      {
        value: 'LIKES_ORGANIC',
        label: 'Organic',
      },
      {
        value: 'LIKES_PROMOTED',
        label: 'Promoted',
      },
    ],
  },
  {
    value: 'IMPRESSIONS_TOTAL',
    label: 'Impressions',
    tooltip: tooltips.impressions,
    extendedMetrics: [
      {
        value: 'IMPRESSIONS_ORGANIC',
        label: 'Organic',
      },
      {
        value: 'IMPRESSIONS_PROMOTED',
        label: 'Promoted',
      },
    ],
  },
  {
    value: 'URL_CLICKS_TOTAL',
    label: 'Link Clicks',
    tooltip: tooltips.linkClicks,
    extendedMetrics: [
      {
        value: 'URL_CLICKS_ORGANIC',
        label: 'Organic',
      },
      {
        value: 'URL_CLICKS_PROMOTED',
        label: 'Promoted',
      },
    ],
  },
  {
    value: 'VIDEO_VIEWS',
    label: 'Video Views',
    tooltip: tooltips.videoViews,
    extendedMetrics: [
      {
        value: 'VIDEO_VIEWS_ORGANIC',
        label: 'Organic',
      },
      {
        value: 'VIDEO_VIEWS_PROMOTED',
        label: 'Promoted',
      },
    ],
  },
];
